export namespace AlertResultExport {
  export type ListItem = {
    uniqueIdentifier: string;
    matchType: string;
    categoryName: string;
    sourceOwnerName: string;
    sourceManufacturerName: string;
    sourceProductName: string;
    sourceRegionName: string;
    sourceRegularPrice: number;
    sourceLowestPrice: number;
    sourceLowestPriceType: string;
    sourceCompetitorPriceVariance: number | null;
    sourceCompetitorLowestPriceVariance: number | null;
    competitorOwnerName: string;
    competitorRegionName: string;
    competitorSellerName: string | null;
    competitorFulfillerName: string | null;
    competitorRegularPrice: number;
    competitorLowestPrice: number;
    competitorLowestPriceType: string;
    sourceProductUrl: string;
    competitorProductUrl: string;
    competitorProductName: null;
    competitorManufacturerName: string | null;
  };

  export type Params = {
    alertId: string;
    sourceOwnerId: string;
    createdDate: string;
  };

  export type Response = {
    alertResultExportList: ListItem[];
  };
}
